import React from 'react';
import { FaCheck, FaLayerGroup } from 'react-icons/fa';
import { PLAN_COMMERCIAL_META_ES } from '../../utils/planDetails';
import { PLAN_LABELS_ES } from '../../utils/planTiers';

/**
 * Teaser PRO compacto bajo el formulario (centro).
 */
export default function LoginPlansCenterTeaser({ onVerPlan, onVerAll }) {
  const meta = PLAN_COMMERCIAL_META_ES.intermediate;

  return (
    <div className="mt-4 rounded-xl border border-violet-500/25 bg-violet-500/[0.08] px-3 py-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-sm font-bold text-e0e3-foreground">
            {PLAN_LABELS_ES.intermediate}
            <span className="ml-2 text-xs font-normal text-e0e3-muted">
              {meta.includedUsers} usuarios · {meta.includedBranches} sucursales
            </span>
          </p>
          <p className="mt-0.5 flex flex-wrap gap-x-2 text-[11px] text-e0e3-muted">
            <span className="inline-flex items-center gap-1">
              <FaCheck className="h-2.5 w-2.5 text-emerald-400" /> Transferencias
            </span>
            <span className="inline-flex items-center gap-1">
              <FaCheck className="h-2.5 w-2.5 text-emerald-400" /> Multi-sucursal
            </span>
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => onVerPlan?.('intermediate')}
            className="rounded-lg border border-white/15 px-2.5 py-1.5 text-xs font-semibold text-e0e3-foreground hover:bg-white/[0.06]"
          >
            Ver PRO
          </button>
          <button
            type="button"
            onClick={onVerAll}
            className="inline-flex items-center gap-1 rounded-lg border border-e0e3-accent/40 bg-e0e3-accent/10 px-2.5 py-1.5 text-xs font-semibold text-e0e3-accent-soft hover:bg-e0e3-accent/20"
          >
            <FaLayerGroup className="h-3 w-3" />
            Todos
          </button>
        </div>
      </div>
    </div>
  );
}
